<template>
  <v-card>
    <v-container style="max-width: 900px">
      <v-row>
        <v-col cols="12" class="d-flex justify-center">
          <v-btn-toggle rounded class="mx-auto">
            <v-btn color="primary" class="white--text" :to="{name: 'renting'}">For Tenants</v-btn>
            <v-btn color="white" :to="{name: 'renting-out'}">For Landlords</v-btn>
          </v-btn-toggle>
        </v-col>
        <v-col cols="12">
          <section class="text-center">
            <h1>For Tenants</h1>
            <p class="lead">FINDING RENT MADE EASY with LocalRent.Online!</p>
          </section>
          <ul class="py-3 px-0" style="list-style: none">
            <li>Ready to move to a New Place or Neighbourhood?</li>
            <li>Looking for an affordable Apartment or a House Rent locally?</li>
            <li>Tired of your high Rent payments and want to find an affordable one?</li>
          </ul>
          <p>We do understand how stressful and frustrating it can be. That is why LocalRent.Online presents the Active Rent Listings from Local Owners and property managers.</p>
          <div class="text-center">
            <v-btn rounded color="primary" :to="{name: 'search'}">Search for rent</v-btn>
          </div>
          <v-row
            align="center"
            justify="center"
            class="py-8"
            :key="index"
            v-for="(feature, index) in features"
          >
            <v-col cols="12" md="6" :order-md="index % 2 == 0 ? 'last' : 'first'">
              <h1 class="display-1 mb-5 font-weight-bold">{{feature.title}}</h1>
              <p class="body-2">{{feature.body}}</p>
            </v-col>
            <v-col cols="12" md="6">
              <div class="icon-circle">
                <v-img max-width="80%" class="mx-auto" :src="feature.img"></v-img>
              </div>
            </v-col>
          </v-row>

          <p>IMAGINE moving to a New place that you have been dreaming of for the next season of your life!</p>
          <p>Why to wait and be even more frustrated with the previous RENT that you wanted to CHANGE?</p>
          <p>SEARCH FOR a NEW RENT Now – the one that you always wanted and that you NEED and be ready to MOVE Forward!</p>
          <div class="text-center">
            <v-btn rounded color="primary" :to="{name: 'search'}">Search for rent</v-btn>
          </div>
        </v-col>
      </v-row>
    </v-container>
  </v-card>
</template>

<script>
export default {
  data() {
    return {
      features: [
        {
          title: "Active Local Listings",
          body:
            "Only Most Recent and active listings that are available for rent in the area",
          img: require("@/assets/home/pics_active-local-listing.svg"),
        },
        {
          title: "Quick and Easy Navigation",
          body:
            "You can easily filter the area or the search criteria to find the most suitable house or apartment to rent for you",
          img: require("@/assets/home/pics_quick-easy-nav.svg"),
        },
        {
          title: "Safe and Reliable",
          body:
            "Dealing with Local Rent Online you can be sure that you and your information is safe and will not be passed on to third parties under any circumstances",
          img: require("@/assets/home/pics_safe-reliable.svg"),
        },
      ],
    };
  },
};
</script>

<style lang="scss" scoped>
</style>